import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FaShopify } from 'react-icons/fa';
import { Button } from 'components';

const StyledShopifyButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: #96bf48;
  border-color: #96bf48;

  &:hover {
    background-color: #7da639;
    border-color: #7da639;
  }

  &:disabled {
    background-color: #96bf48;
    border-color: #96bf48;
    opacity: 0.8;
  }
`;

const ShopifyButton = ({ children, showIcon = true, ...props }) => (
  <StyledShopifyButton {...props}>
    {showIcon && <FaShopify size={20} />}
    {children}
  </StyledShopifyButton>
);

ShopifyButton.propTypes = {
  children: PropTypes.node,
  showIcon: PropTypes.bool,
};

export default ShopifyButton;
